import type {Branded} from '@kapitalist/utils/Branded'
import {brand} from '@kapitalist/utils/Branded'
import type {TGameId} from './index'

// "Untrusted" id types: values not yet checked against authoritative server state (some may
// be from url paths or forms, others just client-passed data we want to avoid accidentally
// trusting).

/**
 * A `games.id` a client supplied that may not name a real game.
 * Find the matching `TGameId` from an authoritative place (e.g. the DB)
 * rather than assuming it's legit.
 */
export type TUntrustedGameId = Branded<string, typeof untrustedGameIdBrand>
export const mkUntrustedGameId = (gameId: string): TUntrustedGameId =>
  brand<TUntrustedGameId>(gameId)
declare const untrustedGameIdBrand: unique symbol

export type TMaybeGameId = TGameId | TUntrustedGameId
